import { Coords } from 'google-map-react'
import { useCallback, useMemo, useState } from 'react'

import { useRouter } from '@hozana/router'

import { Div } from 'elements/layout/Div'

import { GMap } from 'modules/community/pages/CommunityPage/GoogleMapSection/GMap'
import { TPrayerMeeting } from 'modules/meeting/types'

type TPrayerEventMapProps = {
  prayerMeetings: TPrayerMeeting[]
  defaultCenter: Coords
}

const CLICKED_MARKER_ZOOM_LEVEL = 12
const DEFAULT_ZOOM_LEVEL = 6
export const PrayerEventDisplayMap: TFC<TPrayerEventMapProps> = ({ prayerMeetings, defaultCenter }) => {
  const { replace, pathname, query } = useRouter() //#router.replace
  const [center, setCenter] = useState<Coords>(defaultCenter)
  const [zoom, setZoom] = useState<number>(defaultCenter ? CLICKED_MARKER_ZOOM_LEVEL : DEFAULT_ZOOM_LEVEL)

  const onMarkerClick = useCallback(
    (clickedCoords: Coords) => {
      const clickedMeeting = prayerMeetings.find(
        (prayerMeeting) =>
          prayerMeeting.placeAddress.latitude === clickedCoords.lat &&
          prayerMeeting.placeAddress.longitude === clickedCoords.lng,
      )
      const { id: _extracted, ...remainingQuery } = query
      replace({ pathname, query: { ...remainingQuery, meeting: clickedMeeting.id } }, undefined, { shallow: true })
      setCenter(clickedCoords)
      setZoom(CLICKED_MARKER_ZOOM_LEVEL)
    },
    [pathname, prayerMeetings, replace, query],
  )

  const markers = useMemo(
    () =>
      prayerMeetings
        .filter((prayerMeeting) => prayerMeeting.status === 'validated')
        .map((prayerMeeting) => ({
          id: prayerMeeting.id,
          lat: prayerMeeting.placeAddress.latitude,
          lng: prayerMeeting.placeAddress.longitude,
        })),
    [prayerMeetings],
  )

  return (
    <Div h="100%" w="100%" position="absolute">
      <GMap
        membersLocation={markers}
        zoom={zoom}
        center={defaultCenter ?? center}
        onMarkerClick={(clickedCoords) => onMarkerClick(clickedCoords)}
      ></GMap>
    </Div>
  )
}
